<template>
  <div :key="customerId">
    <table
      v-if="products.length > 0"
      class="ui celled small very compact table center aligned productslist"
    >
      <thead>
        <tr>
          <th>{{ $t('Image') }}</th>
          <th class="six wide">{{ $t('Name') }}</th>
          <th>{{ $t('Reference') }}</th>
          <th>{{ $t('Tissu/Col/Poignets') }}</th>
          <th>{{ $t('Combination') }}</th>
          <th class="one wide">{{ $t('Price') }}</th>
          <th>{{ $t('Measure') }}</th>
          <th class="two wide">{{ $t('Ops') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(product, index) in products"
          :key="product.id"
          class="product"
        >
          <td>
            <img
              v-if="product.source != 'formens' && product.customizable != 0"
              alt="Fabric"
              :src="
                'http://www.cottonsociety.com/modules/cs_shirtgenerator/design/img/tissu/219/' +
                getParameter(product, 'TISSU').picture
              "
            />
            <img
              v-else
              alt="Product"
              :src="
                'http://www.cottonsociety.com' +
                '/img/tmp/product_mini_' +
                product.id_product +
                '_1.jpg'
              "
            />
          </td>
          <td>
            <p>{{ product.name }}</p>
          </td>
          <td>
            <div :class="product.source">
              <span v-if="product.source === 'customized'">N/A</span>
              <span v-else>{{ product.reference }}</span>
            </div>
          </td>
          <td class="ticopo">
            <div v-if="product.customizable != 0" class="customized">
              <p>{{ getParameter(product, 'TISSU').name }}</p>
              <p>{{ getParameter(product, 'COLLAR').name }}</p>
              <p>{{ getParameter(product, 'CUFFS').name }}</p>
            </div>
          </td>
          <td class="combination">
            <!-- cashdesk customized product start -->
            <div v-if="product.customizable != 0">
              <i
                v-if="showAttributes[index]"
                class="ui huge angle up icon"
                @click="toggleshowAttributes(index)"
              ></i>
              <i
                v-else
                class="ui huge angle down icon"
                @click="toggleshowAttributes(index)"
              ></i>
              <table
                v-if="showAttributes[index] && getParameterAll(product)"
                class="ui celled small very compact table center aligned attributes-table"
              >
                <tbody>
                  <tr
                    v-for="(attribute, idx) in getParameterAll(product)"
                    :key="idx"
                  >
                    <td>
                      {{
                        //group_id
                        attribute.group_name
                      }}
                    </td>
                    <td>
                      {{
                        //parameter_id, parameter_name, code, parameter_ps_attribute_name
                        attribute.parameter_name
                      }}
                    </td>
                    <td>
                      <span
                        v-if="
                          attribute.parameter_value_id ||
                          attribute.parameter_value_text
                        "
                      >
                        <span
                          :class="{'not-available': attribute.code == 'TISSU' && !availableFabrics[attribute.code]}"
                        >
                          {{
                            // parameter_value_id
                            attribute.parameter_value_text || 'NOT SET'
                          }}</span
                        >
                      </span>

                      <span
                        v-else-if="
                          attribute.name == 'Initiales' ||
                          attribute.code == 'DOUBLURETISSU'
                        "
                        style="color: darkorange"
                        >NOT SET
                      </span>
                      <span v-else class="danger">NOT SET</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- cashdesk customized product end -->
            <div v-else>
              <!-- for prestashop or formens product -->
              <table
                class="ui celled small very compact table left aligned presta-table"
              >
                <tbody>
                  <tr>
                    <td>{{ $t('Product') }}</td>
                    <td :class="product.source">
                      {{ product.id_product }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Combination') }}</td>
                    <td :class="product.source">
                      {{
                        product.id_combination ||
                        product.id_product_attribute ||
                        product.product_attribute_id ||
                        'N/A'
                      }}
                    </td>
                  </tr>
                  <tr
                    v-for="(attribute_name, idx) in Object.keys(
                      product.attribute_list
                    )"
                    :key="idx"
                  >
                    <td>{{ attribute_name }}</td>
                    <td :class="product.source">
                      {{ product.attribute_list[attribute_name] }}
                    </td>
                  </tr>
                  <tr v-if="product.source === 'formens'">
                    <td>{{ $t('Original price') }}</td>
                    <td class="original-price">
                      {{
                        product.original_product_price || product.presta_price | price
                      }}
                    </td>
                  </tr>
                  <tr v-if="product.source === 'formens'">
                    <td>{{ $t('Suggested price') }}</td>
                    <td :class="product.source">
                      {{ product.fms_suggested_price || product.price | price }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td class="price">{{ product.price | price }}</td>
          <td class="measure">
            <div
              v-if="((product.source != 'formens' && product.customizable != 0) || product.source == 'order') && product.isShirt"
            >
              <div v-if="currentCustomer.measures.length > 0">
                <select
                  v-model="product.measure_id"
                  class="ui fluid dropdown selection"
                  placeholder="Measure"
                  style="height: 40px"
                >
                  <option
                    v-for="measure in currentCustomer.measures"
                    :key="measure.id"
                    :value="measure.id"
                  >
                    {{ measure.name }}
                    <br />
                    <span style="font-size: 10px">{{ measure.date_upd }}</span>
                  </option>
                </select>
              </div>
              <measure-modal
                v-else
                @create="
                  (measure) => {
                    products[index].measure_id =
                      measure.id
                  }
                "
              >
                <button
                  ref="measure_modal"
                  slot="activator"
                  class="ui blue button"
                >
                  <i class="add icon"></i>{{ $t('Add measure') }}
                </button>
              </measure-modal>
            </div>
            <div v-else-if="product.source == 'formens'">
              <table
                class="ui celled small very compact table center aligned reference-table"
              >
                <tbody>
                  <tr>
                    <td>{{ $t('Factory reference') }}</td>
                    <td :class="product.source">
                      {{ product.fms_factory_reference || product.formens_ref }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Product type') }}</td>
                    <td :class="product.source">
                      {{ product.fms_product_type || product.product_type }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Pattern base') }}</td>
                    <td :class="product.source">
                      {{ product.fms_pattern_base || product.pattern_base }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Base size') }}</td>
                    <td :class="product.source">
                      {{ product.fms_base_size || product.base_size }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td class="ops">
            <button
              v-if="product.source != 'formens' && product.customizable != 0 && product.isShirt"
              title="Edit this shirt"
              class="ui button icon green"
              @click="openProductModal(product)"
            >
              <i class="edit icon"></i>
            </button>
            <button
              v-if="product.source != 'formens'"
              title="Clone this shirt"
              class="ui button icon orange"
              @click="cloneProduct(product)"
            >
              <i class="clone icon"></i>
            </button>
            <button
              title="Delete this shirt"
              class="ui button icon red"
              @click="openDeleteModal(product)"
            >
              <i class="trash icon"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <p v-if="intersectionOfFormensAndPrestaProducts.length > 0">
      <span class="danger">*</span>
      This cart has same product/combination
      <span class="danger">{{ intersectionOfFormensAndPrestaProducts }}</span>
      from Prestashop search and Formens search. But they have different price
      rules. Please remove the conflict products from either type to continue
      order.
    </p>

    <div class="actions">
      <button
        class="ui compact blue icon button left floated"
        @click="addProduct()"
      >
        <i class="add icon"></i>{{ $t('Add shirt') }}
      </button>
      <div class="search-presta">
        <input
          v-validate="'required'"
          v-model="keywordSearchPresta[customerId]"
          type="text"
          placeholder
          name="box-search-presta"
          @keyup.enter="searchPrestashop()"
        />
        <button
          class="ui compact purple icon button"
          style="color: white"
          @click="searchPrestashop()"
        >
          <i class="search icon"></i>{{ $t('Search Prestashop') }}
        </button>
      </div>
      <div class="search-formens">
        <input
          v-validate="'required'"
          v-model="keywordSearchFormens[customerId]"
          type="text"
          placeholder
          name="box-search-formens"
          @keyup.enter="searchFormens()"
        />
        <button class="ui compact pink icon button" @click="searchFormens()">
          <i class="search icon"></i>{{ $t('Search B2B') }}
        </button>
      </div>
      <div class="ready-to-pay-message">
        {{ readyToPayMessage }}
      </div>
      <button
        :disabled="!readyToPay"
        class="ui green icon button right floated"
        @click="openCartModal()"
      >
        <i class="cart icon"></i>{{ $t('Pay') }}
      </button>
    </div>

    <found-products
      :key="customerId"
      :customer-id="customerId"
      :show="showSearch[customerId]"
      :searching="searching[customerId]"
      :keyword="keywordSearchPresta[customerId]"
      :category="category[customerId]"
      :found-products="foundProducts[customerId]"
      :current-page="currentPage[customerId]"
      @changePageSize="changePageSize"
      @changePage="changePage"
    ></found-products>

    <formens-modal
      class="formens-modal"
      ref="formensModal"
      :formens-product="currentFormensProduct"
      :user="user"
      @close="closeFormensModal"
      @addToCart="addFromFormensToCart"
    ></formens-modal>

    <product-modal ref="productModal"></product-modal>

    <order-modal
      ref="orderModal"
      @switchToOrdersTab="$emit('switchToOrdersTab')"
    ></order-modal>

    <popup-modal
      :index="product_to_delete"
      icon="checkmark"
      cancel_class="ui red basic cancel inverted button"
      confirm_class="ui green ok inverted button"
      text="Are you sure you want to delete this shirt ?"
      @cancel="product_to_delete = null"
      @delete="deleteProduct"
    ></popup-modal>

    <popup-modal
      :index="product_to_update"
      icon="checkmark"
      cancel_class="ui red basic cancel inverted button"
      confirm_class="ui green ok inverted button"
      text="Formens product with this factory reference already exists in cart, are you sure to update it?"
      @cancel="product_to_update = null"
      @delete="updateFormensProductInCart()"
    ></popup-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import uniqid from 'uniqid'
import _ from 'lodash'
import ProductModal from '../../components/Modal/ProductModal'
import OrderModal from '../../components/Modal/OrderModal'
import MeasureModal from '../../components/Modal/MeasureModal'
import FoundProducts from '../../components/Cart/FoundProducts'
import FormensModal from '../../components/Modal/FormensModal'

export default {
  name: 'CartTab',
  components: {
    ProductModal,
    OrderModal,
    MeasureModal,
    FoundProducts,
    FormensModal
  },
  props: {
  },
  data() {
    return {
      loading: false,
      currentProduct: null,
      product_to_delete: null,
      product_to_update: null,
      product_to_update_new_value: null,
      categories: {},
      category: {},
      showSearch: [],
      searching: [],
      language: [],
      keywordSearchPresta: [],
      keywordSearchFormens: [],
      foundProducts: {},
      formensProduct: [],
      pageSize: {},
      currentPage: {},
      showAttributes: {},
      labelshowAttributes: {},
      intersectionOfFormensAndPrestaProducts: [],
      readyToPayMessage: ''
    }
  },
  computed: {
    ...mapGetters({
      currentCustomer: 'getCurrentCustomer',
      products: 'getCartProducts',
      currentShirt: 'getCurrentShirt',
      cartAmount: 'getCartAmount',
      availableFabrics: 'getAvailableFabrics',
      groups: 'getGroups',
      shopAddress: 'getShopAddress',
      user: 'getUser'
    }),
    customerId() {
      return this.currentCustomer.id
    },
    currentCategory() {
      return this.category[this.customerId]
    },
    currentKeywordSearchPresta() {
      return this.keywordSearchPresta[this.customerId]
    },
    currentKeywordSearchFormens() {
      return this.keywordSearchFormens[this.customerId]
    },
    productsLength() {
      return this.products.length
    },
    currentFormensProduct() {
      return this.formensProduct[this.customerId]
        ? this.formensProduct[this.customerId]
        : {}
    },
    readyToPay() {
      return this.checkIfReadyToPay()
    }
  },
  watch: {
    currentCategory() {
      this.$set(this.currentPage, this.customerId, 1)
    },
    currentKeywordSearchPresta() {
      this.$set(this.currentPage, this.customerId, 1)
    },
    currentShirt: {
      deep: true,
      handler(val) {
        if(!val) return;
        this.computeProductPrice(val);
      }
    }
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    openProductModal(shirt) {
      this.$store.dispatch('setCurrentShirt', shirt)
      this.$refs.productModal.open()
    },
    initProduct() {
      const shirt = {
        id: uniqid(),
        name: 'Shirt',
        created: true,
        options: {},
        measure_id: null,
        cart_quantity: 1,
        price: 0,
        source: 'customized',
        isShirt: true,
        customizable: true
      }

      this.groups.forEach((group) => {
        shirt.options[group.id] = {}

        group.parameters.forEach((parameter) => {
          if (!['OPTION', 'SELECT_ONE', 'TEXT'].includes(parameter.type)) return
          shirt.options[group.id][parameter.code] = {}
          parameter.values.some((value) => {
            if (value.default && !shirt.options[group.id][parameter.code].code) {
              shirt.options[group.id][parameter.code] = value
              return true
            }
            return false
          })
        })
      })

      return shirt;
    },
    addProduct() {
      const shirt = this.initProduct()
      this.$store.dispatch('addToCart', shirt);
      this.openProductModal(shirt)
    },
    addFromFormensToCart(product) {
      this.products.forEach((value) => {
        if (value.factory_reference === product.formens_ref) {
          this.product_to_update = value
          this.product_to_update_new_value = product
        }
      })

      if (!this.product_to_update) {
        this.closeFormensModal()
        let formensProduct = {
          id: uniqid(),
          factory_reference: product.formens_ref,
          created: true,
          options: {},
          cart_quantity: 1,
          price: product.price,
          source: 'formens'
        }
        formensProduct = Object.assign(formensProduct, product)
        this.$store.dispatch('addToCart', formensProduct);
      }
    },

    updateFormensProductInCart() {
      this.products.splice(
        this.products.indexOf(this.product_to_update),
        1
      )
      this.product_to_update = null
      this.addFromFormensToCart(this.product_to_update_new_value)
    },

    cloneProduct(product) {
      /* Copy the product without the reactives properties of VueJS. */
      const newProduct = JSON.parse(JSON.stringify(product))

      newProduct.id = uniqid()
      newProduct.created = true
      this.$store.dispatch('addToCart', newProduct);
    },
    deleteProduct() {
      this.products.splice(
        this.products.indexOf(this.product_to_delete),
        1
      )
      this.product_to_delete = null
    },
    openDeleteModal(shirt) {
      this.product_to_delete = shirt
    },
    getCategories() {
      axios
        .get('/categories')
        .then((response) => {
          this.categories = response.data.categories
        })
        .finally(() => {
          // this.$set(this.searching, this.customerId, false);
        })
    },
    searchPrestashop() {
      this.$set(this.showSearch, this.customerId, true)
      this.$set(this.searching, this.customerId, true)
      axios
        .get('/products', {
          params: {
            id_category: this.category[this.customerId]
              ? this.category[this.customerId].id_category
              : '',
            product_search: this.keywordSearchPresta[this.customerId],
            searcher_email: this.user.email,
            size: this.pageSize[this.customerId]
              ? this.pageSize[this.customerId]
              : 10,
            page: this.currentPage[this.customerId]
          }
        })
        .then((response) => {
          // eslint-disable-next-line no-param-reassign
          this.$set(this.foundProducts, this.customerId, response.data)
        })
        .finally(() => {
          this.$set(this.searching, this.customerId, false)
        })
    },
    searchFormens() {
      const keyword = this.keywordSearchFormens[this.customerId]
      if (!keyword) return
      axios
        .get(`/formens/order/${keyword}`)
        .then((response) => {
          let formensProduct = {
            formens_ref: keyword
          }
          formensProduct = Object.assign(
            formensProduct,
            response.data.product_info
          )
          this.$set(this.formensProduct, this.customerId, formensProduct)
          this.$refs.formensModal.open()
        })
        .finally(() => {})
    },

    closeFormensModal() {
      this.$set(this.keywordSearchFormens, this.customerId, '')
      this.$refs.formensModal.close()
    },

    getParameter(product, code) {
      let parameterCode = ''
      let groupId = 0
      this.groups.forEach((group) => {
        group.parameters.forEach((parameter) => {
          if (parameter.code === code) {
            parameterCode = parameter.code
            groupId = group.id
          }
        })
      })
      return product.options[groupId] && product.options[groupId][parameterCode]
        ? product.options[groupId][parameterCode]
        : {}
    },
    getParameterAll(product) {
      let parameterCode = ''
      let groupId = 0
      const attributes = []
      this.groups.forEach((group) => {
        group.parameters.forEach((parameter) => {
          parameterCode = parameter.code
          groupId = group.id

          const parameterValue =
            product.options[groupId] && product.options[groupId][parameterCode]
              ? product.options[groupId][parameterCode]
              : {}
          const parameterValueText =
            typeof parameterValue === 'string'
              ? parameterValue
              : parameterValue.name

          const attribute = {
            group_id: group.id,
            group_name: group.name,
            code: parameter.code,
            parameter_id: parameter.code,
            parameter_name: parameter.name,
            parameter_value: parameterValue,
            parameter_value_id: parameterValue.code,
            parameter_value_text: parameterValueText
          }

          attributes.push(attribute)
        })
      })
      return attributes
    },
    computeProductPrice(product) {
      const price = this.getProductPrice(product);
      // eslint-disable-next-line no-param-reassign
      product.price = price;
      return price;
    },
    getProductPrice(product) {
      // calculate price for product added from formens search
      if (!product.customizable) {
        return product.price
      }

      // calculate price for cashdesk customized shirt
      let price = 0
      Object.keys(product.options).forEach((optionId) => {
        const option = product.options[optionId]
        Object.keys(option).forEach((parameterId) => {
          const parameter = option[parameterId]
          if (parameter.price) price += parseFloat(parameter.price)
        })
      })

      if (price === 0)
        return product.price

      return price;
    },
    openCartModal() {
      this.$refs.orderModal.open()
    },
    checkIfReadyToPay() {
      let payBlockers = 0
      const productIdAndAttributeIdOfFormensProducts = []
      const productIdAndAttributeIdOfPrestaProducts = []

      this.readyToPayMessage = ''

      // Block if no products in the Cart.
      if (this.products.length <= 0) {
        this.readyToPayMessage = 'No products in the cart'
        return false
      }

      // Check for missing information on each products
      this.products.forEach((product) => {

        // Check Formens product
        if (product.source === 'formens') {
          // formens products
          if (product.price <= 0) {
            this.readyToPayMessage = 'Formens product price is 0'
            payBlockers += 1
          }
          productIdAndAttributeIdOfFormensProducts.push(
            `${product.id_product}/${product.id_combination}`
          )
          return;
        }

        if(product.source === 'order') {
          if(!product.measure_id && product.isShirt) {
            this.readyToPayMessage = 'Une mesure n\'est pas définie'
            payBlockers += 1
          }
          return;
        }

        // Check for customizable product
        if (product.customizable !== '0') {

          // Check presence of measure
          if (!product.measure_id) {
            this.readyToPayMessage = 'Une mesure n\'est pas définie'
            payBlockers += 1
          }

          // Check presence of an available fabric
          const productTissu = this.getParameter(product, 'TISSU').code
          if (!this.availableFabrics[productTissu]) {
            this.readyToPayMessage = 'Le tissu n\'est pas disponible'
            payBlockers += 1
          }

          // Check presence of required value for selected parameters
          const attributes = this.getParameterAll(product)
          attributes.forEach((attribute) => {
            if (
              !(
                attribute.group_name === 'Initiales' ||
                attribute.code === 'DOUBLURETISSU'
              ) &&
              !attribute.parameter_value_text
            ) {
              this.readyToPayMessage = `Le paramêtre ${attribute.parameter_name} n'est pas renseigné`
              payBlockers += 1
            }
          })
          return;
        }

        // Check products added from Prestashop
        productIdAndAttributeIdOfPrestaProducts.push(
          `${product.id_product}/${product.id_combination}`
        )

      })

      this.intersectionOfFormensAndPrestaProducts = _.intersection(
        productIdAndAttributeIdOfFormensProducts,
        productIdAndAttributeIdOfPrestaProducts
      )
      if (this.intersectionOfFormensAndPrestaProducts.length > 0) {
        this.readyToPayMessage = 'Intersection of Formens and Prestashop products'
        payBlockers += 1
      }

      return payBlockers === 0
    },
    toggleshowAttributes(index) {
      this.$set(
        this.showAttributes,
        index,
        this.showAttributes[index] ? !this.showAttributes[index] : true
      )
    },
    setSearchCategory(val) {
      if (!val) return
      this.$set(this.category, this.customerId, val)
    },
    changePageSize(val) {
      this.$set(this.pageSize, this.customerId, val)
      this.searchPrestashop()
    },
    changePage(val) {
      this.$set(this.currentPage, this.customerId, val)
      this.searchPrestashop()
    }
  }
}
</script>

<style scoped>
.productslist .product img {
  height: 50px;
  width: auto;
}

p {
  line-height: 15px;
}

.search-presta {
  display: flex;
  justify-content: space-between;
}

.search-formens {
  display: flex;
  justify-content: space-between;
}

input {
  width: 165px;
}

.formens-modal {
  position: fixed;
  z-index: 1;
}

.actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 2px;
}

.ticopo {
  width: 180px;
}

.combination {
  width: 159px;
}

.formens {
  color: #e61a8d;
}

.prestashop {
  color: purple;
}

.original-price {
  color: blue;
}

.not-available {
  color: red;
}

.customized {
  /* color: #2185d0; */
  color: blue;
}

.danger {
  color: red;
}

.attributes-table tr {
  height: 14px;
}

.attributes-table td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// CartTab.vue?371f39aa